
export const generalTips = [
  {
    header: 'advise',
    index: 1,
    content: [
      {
        subHeader: 'advise_sh_1',
        list: ['advise_list_11', 'advise_list_12', 'advise_list_13', 'advise_list_14', 'advise_list_15'],
        paragraphs: ['advise_para_11', 'advise_para_12', 'advise_para_13']
      },
      {
        subHeader: 'advise_sh_2',
        list: ['advise_list_21', 'advise_list_22'],
        paragraphs: []
      },
      {
        subHeader: 'advise_sh_3',
        list: ['advise_list_31', 'advise_list_32'],
        paragraphs: []
      }
    ]
  },
  {
    header: 'monitor',
    index: 2,
    content: [
      {
        subHeader: 'monitor_sh_1',
        list: ['monitor_list_11', 'monitor_list_12', 'monitor_list_13'],
        paragraphs: []
      },
      {
        subHeader: 'monitor_sh_2',
        list: [],
        paragraphs: ['monitor_para_2']
      }
    ]
  }
]

export const definitions = [
  'definition_1',
  'definition_2',
  'definition_3',
  'definition_4'
]

export const bmiCategories = {
  extremeUnderweight: { Category: 'extreme_uw', Color: '#FE0000', Recommendation: ['below21'] },
  severeUnderweight: { Category: 'severe_uw', Color: '#FF6600', Recommendation: ['below21'] },
  moderateUnderweight: { Category: 'moderate_uw', Color: '#FF9934', Recommendation: ['below21'] },
  mildUnderweight: { Category: 'mild_uw', Color: '#FFFF00', Recommendation: ['below21'] },
  normal: { Category: 'normal', Color: '#92D14F', Recommendation: ['below21', 'between21and25'] },
  overweight: { Category: 'overweight', Color: '#FFFF00', Recommendation: ['above25'] },
  obese: { Category: 'obese', Color: '#FE0000', Recommendation: ['above25'] }
}

export const recommendationList = {
  below21: 'below21_recomendation',
  between21and25: '21and25_recomendation',
  above25: 'above25_recommendation'
}
